export default {
  'auth.login_title': 'Log in',
  'auth.login_subtitle': 'QR Code Login System',
  'auth.email_label': 'Email',
  'auth.password_label': 'Password',
  'auth.logging_in': 'Logging in...',
  'auth.login_button': 'Log in',
  'auth.no_account': "Don't have an account?",
  'auth.signup_link': 'Sign up',
  'auth.generate_qr_on_pc': 'Generate QR on PC',
  'auth.login_failed': 'Login failed.',

  'auth.signup_title': 'Sign up',
  'auth.signup_subtitle': 'Create a new account',
  'auth.confirm_password_label': 'Confirm Password',
  'auth.password_placeholder': 'At least 6 characters',
  'auth.confirm_password_placeholder': 'Re-enter your password',
  'auth.signing_up': 'Signing up...',
  'auth.signup_button': 'Sign up',
  'auth.has_account': 'Already have an account?',
  'auth.login_link': 'Log in',
  'auth.signup_success': 'Sign up complete! Redirecting to login page...',
  'auth.password_mismatch': 'Passwords do not match.',
  'auth.password_too_short': 'Password must be at least 6 characters.',
  'auth.signup_failed': 'Sign up failed.',

  'auth.email_placeholder': 'your@email.com',
};
